'use client';

import React, { useEffect, useState } from 'react';
import { useWindowInfo } from '@faceless-ui/window-info';
import { usePathname } from 'next/navigation';
import useIntersect from '../../../hooks/useIntersect';
import { constructClassName } from '../../../utils/constructClassName';
import styles from './styles.module.scss';
import breakpoints from '../../../styles/queries/index.module.scss';

interface Props {
  children: React.ReactNode;
  delay?: number;
  direction?: 'left' | 'right' | 'up' | 'down';
  duration?: number;
  noUnload?: boolean;
}

export const SlideInContainer: React.FC<Props> = ({
  children,
  delay = 0,
  direction = 'up',
  duration = 800,
  noUnload = false,
}) => {
  const [loaded, setLoaded] = useState(false);
  const [setNote, entry] = useIntersect({
    threshold: 0.5,
  });
  const pathname = usePathname();
  const { width } = useWindowInfo();

  useEffect(() => {
    if (!noUnload) {
      setLoaded(false);
    }
  }, [pathname, noUnload]);

  useEffect(() => {
    if (entry?.isIntersecting) {
      setTimeout(() => {
        setLoaded(true);
      }, delay);
    }
  }, [delay, entry?.isIntersecting, pathname, width]);


  if ((width || 0) <= parseFloat(breakpoints.md)) {
    return <React.Fragment>{children}</React.Fragment>;
  }

  return (
    <div
      className={styles.container}
      // @ts-expect-error TODO: fix this
      ref={setNote}
    >
      <div
        className={constructClassName([
          styles.slidingContainer,
          loaded ? styles.slidingContainerActive : '',
        ])}
        style={{
          transform: loaded
            ? `translate${direction === 'left' || direction === 'right' ? 'X' : 'Y'}(0)`
            : `translate${direction === 'left' || direction === 'right' ? 'X' : 'Y'}(${direction === 'left' || direction === 'down' ? '-' : ''}60%)`,
          transition: `all ${duration}ms ease-in-out`,
        }}
      >
        {children}
      </div>
    </div>
  );
};
